<section class="challenges-area pt-100 pb-70">
    <div class="container">
        <div class="section-title white-title">
            <!-- <span>Our Methodology</span> -->
            <h2 class="font-family003">Our Innovative Products and Solutions Empower Companies which enable business growth and efficiency.</h2>
        </div>

        <div class="row match-height">
            <div class="col-md-4 col-12">
                <div class="single-challenges overly-one">
                    <div class="overly-two">
                        <!-- <i class="flaticon-threat"></i> -->
                        <img src="assets/img/customers/1.png" alt="test" class="avatar img-100 rounded-circle p-3 my-4">
                        <h3 class="font-018 font-family004">Smart Kavalar</h3>
                        <p>To seek police assistance instantly in emergency situations such as physical emergencies, eve teasing, kidnapping or natural disasters etc.</p>
                        <span class="flaticon-threat"></span>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="single-challenges overly-one">
                    <div class="overly-two">
                        <!-- <i class="flaticon-cyber-security-1"></i> -->
                        <img src="assets/img/customers/3.png" alt="test" class="avatar img-100 rounded-circle p-3 my-4">
                        <h3 class="font-018 font-family004">Smart DL/RC</h3>
                        <p>The Driving License and Registration Certificate is upgraded to Smart Card version. The DL/RC Certificate’s information is stored electronically in a microprocessor chip. The data of an individual is stored in the server.</p>
                        <span class="flaticon-cyber-security-1"></span>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="single-challenges overly-one">
                    <div class="overly-two">
                        <!-- <i class="flaticon-password"></i> -->
                        <img src="assets/img/customers/4.png" alt="test" class="avatar img-100 rounded-circle p-3 my-4">
                        <h3 class="font-018 font-family004">Smart Cities</h3>
                        <p>A smart city uses ICT to improve operational efficiency. The main goal of a smart city is to optimize city functions and promote economic growth.</p>
                        <span class="flaticon-password"></span>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="single-challenges overly-one">
                    <div class="overly-two">
                        <!-- <i class="flaticon-cyber"></i> -->
                        <img src="assets/img/customers/2.png" alt="test" class="avatar img-100 rounded-circle p-3 my-4">
                        <h3 class="font-018 font-family004">Road Safety</h3>
                        <p>We deployed this app mainly to provide safety precaution to avoid accident.</p>
                        <span class="flaticon-cyber"></span>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="single-challenges overly-one">
                    <div class="overly-two">
                        <!-- <i class="flaticon-password"></i> -->
                        <img src="assets/img/customers/erp.png" alt="test" class="avatar img-100 rounded-circle p-3 my-4">
                        <h3 class="font-018 font-family004">Enterprise ERP</h3>
                        <p>Enterprise resource planning (ERP) is a platform. Companies use to manage and integrate the essential parts of their businesses.</p>
                        <span class="flaticon-password"></span>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="single-challenges overly-one">
                    <div class="overly-two">
                        <!-- <i class="flaticon-password"></i> -->
                        <img src="assets/img/customers/sl.png" alt="test" class="avatar img-100 rounded-circle p-3 my-4">
                        <h3 class="font-018 font-family003">Shipping & Logistics</h3>
                        <p>When an unknown printer took a galley of type and scrambled it to make a book.</p>
                        <span class="flaticon-password"></span>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="single-challenges overly-one">
                    <div class="overly-two">
                        <!-- <i class="flaticon-password"></i> -->
                        <img src="assets/img/customers/edu.png" alt="test" class="avatar img-100 rounded-circle p-3 my-4">
                        <h3 class="font-018 font-family003">Education</h3>
                        <p>To ensure that students who study in Government schools are afforded the opportunity to excel in academics, fine arts and sports, a special scheme in the name of Model Schools is being implemented.</p>
                        <span class="flaticon-password"></span>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-12">
                <div class="single-challenges overly-one">
                    <div class="overly-two">
                        <!-- <i class="flaticon-password"></i> -->
                        <img src="assets/img/customers/dm.png" alt="test" class="avatar img-100 rounded-circle p-3 my-4">
                        <h3 class="font-018 font-family003">Digital Marketing</h3>
                        <p>Digital marketing is the act of promoting products and services through digital channels, such as social media, SEO, email, and mobile apps.</p>
                        <span class="flaticon-password"></span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>